import api from '../../../api/clinique/_prestation'

const state = () => ({
    tarif_group_prestation: {},
    tarif_liste_medicaments: {},
})

// getters
const getters = {
    tarif_group_prestation: (state) => {
        return state.tarif_group_prestation
    },

    tarif_liste_medicaments: (state) => {
        return state.tarif_liste_medicaments
    },
}

// mutations
const mutations = {
    SET_TARIF_GROUP_PRESTATION(state, exam) {
        state.tarif_group_prestation = exam
    },

    SET_TARIF_LISTE_MEDICAMENTS(state, exam) {
        state.tarif_liste_medicaments = exam
    },
}

// actions
const actions = {
    getTarifByGroupPrestation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifByGroupPrestation(data).then(
                (response) => {
                    commit("SET_TARIF_GROUP_PRESTATION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveBulletinAnalyse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveBulletinAnalyse(data).then(
                response => {
                    dispatch
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveDemandeExamen({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveDemandeExamen(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTarifListePrestation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifListePrestation(data).then(
                (response) => {
                    commit("SET_TARIF_LISTE_MEDICAMENTS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    setPaidDemandeAnalyse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.setPaidDemandeAnalyse(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    setPaidDemandeExamen({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.setPaidDemandeExamen(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    setPaidPharmacieArticle({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.setPaidPharmacieArticle(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    setPaidProtocoleConstitution({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.setPaidProtocoleConstitution(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}